import { jsx as s, jsxs as h } from "react/jsx-runtime";
import x, { useRef as R, useState as c, useEffect as w } from "react";
import o, { css as n } from "styled-components";
import { u as y } from "../chunks/useForwardRef.7bf5d172.js";
import { m as P } from "../chunks/breakpoints.907eaecd.js";
import { e as j } from "../chunks/vendor_rango__tokens.38ee67b0.js";
const z = o.div.withConfig({
  displayName: "Host",
  componentId: "sc-afmzju-0"
})(["", ""], P.sm(n(["width:100% !important;"]))), L = o.div.withConfig({
  displayName: "Progress",
  componentId: "sc-afmzju-1"
})(["position:relative;height:var(--size-half);background-color:var(--elements-bg-color-02);width:100%;border-radius:var(--border-radius-circular);&::before{content:'';position:absolute;top:0;bottom:0;border-radius:var(--border-radius-circular);", " background-color:var(--elements-bg-color-04);transition-property:all;transition-timing-function:var(--curve-expressive-entrance);transition-duration:var(--duration-moderate-01);}"], ({
  $progressValue: r
}) => r && n(["width:", ";"], r)), N = o.div.withConfig({
  displayName: "RangoProgressLine",
  componentId: "sc-afmzju-2"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:var(--spacing-1x);"]), W = o.span.withConfig({
  displayName: "Value",
  componentId: "sc-afmzju-3"
})(["", " color:var(--text-label-color);", " transition-property:margin-left;transition-timing-function:var(--curve-expressive-entrance);transition-duration:var(--duration-moderate-01);"], j, ({
  $labelWidth: r,
  $progressValue: e
}) => r && e && n(["margin-left:calc(", " - ", ");"], e, r)), C = x.forwardRef(({
  value: r = 0,
  showValue: e = !1,
  ...d
}, m) => {
  const f = y(m), t = R(null), [p, g] = c("0px"), [a, u] = c("0%");
  w(() => {
    v();
  }, [r, e]);
  const v = () => {
    u(`${r}%`), b();
  }, b = () => {
    if (t.current) {
      const l = t.current.offsetWidth;
      let i = "0px";
      r === 100 ? i = `${l}px` : r !== 0 && (i = `${l / 2}px`), g(i);
    }
  };
  return /* @__PURE__ */ s(z, { ...d, ref: f, children: /* @__PURE__ */ h(N, { title: "progress-line", role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": r, "data-testid": "rango-progress-line", "data-range-component": "rango-progress-line", "data-is-rango": !0, children: [
    /* @__PURE__ */ s(L, { $progressValue: a }),
    /* @__PURE__ */ s(W, { ref: t, value: r, $labelWidth: p, $progressValue: a, children: e && a })
  ] }) });
});
C.displayName = "RangoProgressLine";
export {
  C as RangoProgressLine
};
